import { ApiResponse } from 'apisauce';
import { restApi } from '../../api';
import {
  CatalogBulkAddClassificationsRequest,
  CatalogBulkAddCustomersRequest,
  CatalogBulkAddSalesRepsRequest,
  CatalogBulkBaseRequest,
} from './catalogsBulk.repository.types';

const PATH = '/catalogs-bulk';

export const bulkActivateCatalogs = (data: CatalogBulkBaseRequest): Promise<ApiResponse<void>> =>
  restApi.post<void>(`${PATH}/activate`, data);

export const bulkDeactivateCatalogs = (data: CatalogBulkBaseRequest): Promise<ApiResponse<void>> =>
  restApi.post<void>(`${PATH}/deactivate`, data);

export const bulkDeleteCatalogs = (data: CatalogBulkBaseRequest): Promise<ApiResponse<void>> =>
  restApi.post<void>(`${PATH}/delete`, data);

export const bulkAddCustomers = (
  data: CatalogBulkAddCustomersRequest,
): Promise<ApiResponse<void>> => restApi.post<void>(`${PATH}/add-customers`, data);

export const bulkAddSalesRepresentatives = (
  data: CatalogBulkAddSalesRepsRequest,
): Promise<ApiResponse<void>> => restApi.post<void>(`${PATH}/add-sales-representatives`, data);

export const bulkAddClassificationPermissions = (
  data: CatalogBulkAddClassificationsRequest,
): Promise<ApiResponse<void>> => restApi.post<void>(`${PATH}/add-classification-permissions`, data);
